var _rect, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectedToday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEEFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_3002",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#002953"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_3002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0156 9.51562C21.5038 9.02749 22.296 9.02845 22.7842 9.5166C23.2722 10.0048 23.2723 10.7961 22.7842 11.2842L17.667 16.4004L22.7832 21.5166C23.2713 22.0048 23.2713 22.7961 22.7832 23.2842C22.2952 23.772 21.5046 23.7721 21.0166 23.2852L15.8984 18.167L10.7842 23.2832C10.2961 23.7708 9.50477 23.7714 9.0166 23.2832C8.52896 22.7951 8.52953 22.0045 9.0166 21.5166L14.1318 16.4004L9.01562 11.2852C8.52802 10.7971 8.52817 10.0056 9.01562 9.51758C9.50378 9.02942 10.296 9.02943 10.7842 9.51758L15.8984 14.6318L21.0156 9.51562Z",
    fill: "#FF0000",
    stroke: "#FE8F8F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedToday);
export default __webpack_public_path__ + "static/media/RejectedToday.0af9285ce76b9d5ba5b243da4f937db7.svg";
export { ForwardRef as ReactComponent };